<template>
  <div class="cage-child">
    <search-child
      @sendTagAgeId="getTagAgeId(arguments)"
      :monthAgeData="monthAgeData"
    ></search-child>
    <div class="cage-person paddoffset">
      <span class="cage-person-txt">
        <!-- 《母爱好时光》节目主持人、全国金话筒奖获得者，黑龙江广播电视台十佳主持人，黑龙江省妇幼保健与优生育协会促进自然分娩专业委员会常务委员。
        <img
          src=""
          alt
        /> -->
      </span>
    </div>
    <van-sticky :offset-top="55">
      <div :class="isfixed ? 'sticky' : ''">
        <!-- 育儿音频 医生专辑切换 -->
        <ul class="paddingSet baby-tag">
          <li
            @click="tagClick(index)"
            v-for="(item, index) of tabList"
            :class="tagActive === index ? 'baby-tag-active' : ''"
            :key="item.id"
          >
            {{ item.name }}
          </li>
        </ul>
        <cage-tab
          v-show="tag_ye"
          @sendId="getClassId"
          :tagList="tagList"
        ></cage-tab>
      </div>
    </van-sticky>
    <van-list
      v-show="tag_ye"
      v-model="pageParams.loading"
      :finished="pageParams.audioFinished"
      :finished-text="pageParams.bottomText"
      @load="getDataList(audiObj)"
      error-text="请求失败，点击重新加载"
    >
      <babyAudioList
        ref="AudioList"
        :Index="playIndex"
        @sendNext="sendNext"
        @currentAudioWay="currentAudioWay(arguments)"
        @clearTimeWay="clearTimeWay"
        :playTime="playTime"
        :audioParam="audioParams"
        :audioList="audioList"
        :allNewAudio='allNewAudio'
        @playSensor="playSensor"
      ></babyAudioList>
    </van-list>
    <van-list
      v-if="tag_doctor"
      v-model="pageDoctorParams.loading"
      :finished="pageDoctorParams.audioFinished"
      :finished-text="pageDoctorParams.bottomText"
      error-text="请求失败，点击重新加载"
      @load="initAllExpert"
    >
      <doctor-album :page="pageDoctorParams.page" :ExpertList="ExpertList">
      </doctor-album>
    </van-list>
    <myMusic
      :key="componentKey"
      @pauseaudioparams="pauseaudioParams"
      @playaudioparams="playaudioParams"
      @addPalyNum="addPalyNum"
      @playSensor="playSensor"
      ref="musicAudio"
      columName="凯淇育儿"
      @senDetail="senDetail"
      @audio-end="audioEvenTend"
      @listenLogin="listenLogin"
      :playTime="playTime"
      :audioParams="audioParams"
    />
    <back-xmh @goHomeTap="goHomeTap" v-if="showShareCagechild"></back-xmh>
    <to-top></to-top>
    <login-tip
      :show="checkLogin"
      @confirmWay="confirmWay"
      @cancleWay="cancleWay"
    ></login-tip>
  </div>
</template>
<script>
import { TestUserAgent, isUserLogin,MakeDurationToSeconds,globalGoLogin} from "@/assets/js/common.js"; //工具类
import backXmh from "./component/backxmh"; //返回星妈会图标组件
import toTop from "@/components/common/toTopKaiqi"; //回到顶部组件
import API from "@/utils/axiosApi/cageChildApi.js"; //请求pi
import doctorAlbum from "./component/doctoralbum"; //医生专辑组件
import babyAudioList from "./component/babyaudiolist"; //育儿音频组件
import searchChild from "./component/search"; //搜索组件
import cageTab from "./component/tab"; //标签组件
import myMusic from "@/components/contents/parentingAudio/parentingAudio_1.0.vue"; //音频组件
import loginTip from "../calendar/component/logintip";
export default {
  name: "cagechild",
  data() {
    return {
      componentKey:0, //音频组件key值
      playId: null,
      checkLogin: false,
      isfixed: false, //固定顶部
      audiObj: {
        tagAgeId: "",
        tagClassId: "",
      }, //月龄和标签id
      userInfo: JSON.parse(localStorage.getItem("userInfo")), //个人信息
      tagList: [], //标签数组
      monthAgeData: [
        {
          name: "全部",
          id: 0,
        },
      ], //月龄数组
      ExpertList: [], //医生数据
      tab_id: "", //当前标签id
      playIndex: 0, //音频播放索引
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        bottomText: "",
        audioFinished: false,
      }, //育儿音频列表参数
      pageDoctorParams: {
        page: 1,
        size: 10,
        error: false,
        loading: false,
        bottomText: "",
        audioFinished: false,
      }, //医生专辑列表参数
      newPageParams: {
        page: 1,
        size: 10,
      },//最新音频分页
      playTime: 0, //音频播放时间

      audioParams: {}, //当前播放音频信息

      audioList: [], //音频数组
      sensorsFlag: true,
      sensorsFlagdoctor: true,
      tabList: [
        {
          id: "0",
          name: "育儿音频",
        },
        {
          id: "1",
          name: "医生专辑",
        }, //tab切换
      ],
      tagActive: 0, //tab切换当前索引
      allNewAudio:[],//最新的音频数据
      list:[], //最新的音频跟列表音频切换
      totalElements:0, //最新音频总数
      index:0, //详情回来最新音频下标赋值
      doctorKq:'', //医生主页回来 kq
      isStatus:0 //存储音频当前播放还是暂停
    };
  },
  components: {
    searchChild,
    cageTab,
    babyAudioList,
    doctorAlbum,
    backXmh,
    toTop,
    myMusic,
    loginTip,
  },

  watch: {
    audioParams: {
      handler(newValue, oldValue) {
        if (newValue.isPlay) {
          this.audioParams.isKq = "kq";
        }
      },
      deep: true,
    },
  },
  mounted() {

    this.setNewAudio();
    window.addEventListener("scroll", this.handleScroll);
    this.initMonthAge(); // 初始化月龄
    if (this.showShareCagechild) {
      this.goHomeSensor("曝光");
    }
     var shareDataParams = {
      shareLink: window.location.href,
      shareDesc: "超1000万中国家庭都在看，快乐育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会-凯淇育儿",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },

  computed: {
    tag_ye() {
      return this.tabList[this.tagActive].id === "0";
    },
    tag_doctor() {
      return this.tabList[this.tagActive].id === "1";
    },
    showShareCagechild() {
      return this.$route.query.share === "cagechild";
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.name == 'doctor'){
        vm.doctorKq = 'doctor' //医生主页回来

      }
      vm.$store.commit("changeIncludes", ["cagechild"]);
    });
  },
   beforeRouteLeave (to, from, next) {
      if(to.path == '/doctor'){ //跳转到医生主页存储当前音频数据
        this.audioParams.isKq = 'kq'
        this.audioParams.only = 'only'
        if(this.$refs.musicAudio.$refs.player.paused){ //拿到音频的当前状态
          this.isStatus = 0
        }else{
          this.isStatus = 1
        }
        this.$store.commit('addAudio',
        {
          item:this.audioParams,
          time:this.$refs.musicAudio.$refs.player.currentTime,
          isStatus:this.isStatus
        })
        this.audioParams = {} //必须在进入医生主页给音频信息清空 不然医生主页跟凯琪首页第二次联动会播放两个音频
        this.playIndex = 0 //下标清零 不然医生主页过来点击组件进详情会拿错id
        if(this.allNewAudio == ''){ //跳转医生页面数据会丢失，请求数据返回来匹配id
          this.setNewAudio()
        }
      }


      next()
  },
  deactivated() {
    // this.audioList[this.playIndex].isPlay=false
    // this.audioParams=this.audioList[0]
    this.audioParams.isPlay = false;
  },
  activated() {
    this.$refs.musicAudio.$refs.player.load() //重新播放 解决安卓医生主页返回凯琪首页不播放问题
    this.componentKey += 1 //key值变化更新渲染音频组件
    const playStatus = sessionStorage.getItem("currentPlayStatus") || "";
    const { page, id,isNewAudio } = this.$store.state.recordAudio;
    console.log(page)
    if (page != "" && id !== "" && playStatus !== "" && this.doctorKq != 'doctor') { //不在医生主页返回
      if(!isNewAudio){
        this.pageParams.loading = true;
        this.pageParams.audioFinished = false;
        this.audioList = [];
      }
      this.allNewAudio = []
      let pageArr = [];
      let i = 1;
      while (i <= page) {
        pageArr.push(i);
        i++;
      }

      let parama = pageArr.map((res) => {
        return new Promise((reslove) => {
          if(isNewAudio){
            this.newPageParams.page = res;
            this.setNewAudio("", (k) => {
              reslove(k);
            });
          }else{
            this.pageParams.page = res;
            this.getDataList(this.audiObj, (k) => {
              reslove(k);
            });
          }
        });
      });
      Promise.all(parama)
        .then((result) => {
          let newaudioList = [];
          let n = 0;
          while (n <= result.length - 1) {
            newaudioList = newaudioList.concat(result[n].data.data);
            n++;
          }
          if(isNewAudio){
            this.list = this.allNewAudio =newaudioList
          }else{
            this.list = this.audioList =newaudioList
          }
          var { audioTime, id } = this.$store.state.recordAudio;
          let _index = this.list.findIndex((res) => res.id === id);
          console.log(this.list)
          this.playIndex = _index;
          if (playStatus === "1") {
              this.list[_index].isPlay = true;
              setTimeout(()=>{
                this.playTime = audioTime;
              },300)

          } else {
            this.list[_index].isPlay = false;
            this.$refs.musicAudio.getTime();
          }

          this.$nextTick(() => {
            setTimeout(() => {
              this.playTime = audioTime;
            }, 300);
          });
          this.audioParams = this.list[_index];
          this.index = _index //给最新音频赋值下标
        })

        .catch(function(r) {
          console.log(r);
        });
    }
    //医生主页回来
    if(this.doctorKq == 'doctor'){
      this.audioList.forEach((res) => {
        res.isPlay = false; //给凯琪首页数据播放状态全部设为false
      });
      const {time,isStatus,item} = this.$store.state.AudioLinkage //取vuex里医生主页离开存的音频

      this.$nextTick(()=>{
        if(this.allNewAudio[0].id == item.id){

        }else{
          this.allNewAudio.unshift(item) //添加到最新音频头部
        }
        this.audioParams = this.allNewAudio[0];
        if(isStatus){
          this.audioParams.isPlay = true;
          this.$refs.musicAudio.$refs.player.play() //不加这段状态是播放音频其实是暂停
          this.playTime = time;
        }else{
          this.audioParams.isPlay = false;
          this.playTime = time;
          this.$refs.musicAudio.getTime();

        }
        setTimeout(()=>{
          this.playTime = time;
        },300)
      })

    }

    this.doctorKq = '' //清除返回path
  },

  methods: {
    playSensor(name){
      let total = MakeDurationToSeconds(this.audioParams.durationStr);
      let num = this.$refs.musicAudio.current / total;
      sensors.track("Audio_and_video_playback", {
        content_id:String(this.audioParams.id) ,
        content_title: this.audioParams.name,
        content_topic: this.audioParams.audioClassify ? this.audioParams.audioClassify : this.audiObj.tagClassName,
        position: 0,
        length_of_time: total,
        video_duration:String(this.$refs.musicAudio.current) ,
        is_finished: num >= 0.8 ? true : false,
        Content_column: '凯淇育儿',
        doctor: this.audioParams.name ? this.audioParams.name : '',
        Playback_status: name
      });
    },
    addPalyNum() {
      let id = this.audioParams.id;

      if (this.playId == id) return;

      API.addPlayNum({ id: id }, (res) => {
        if (res.code == 200) {
          this.playId = id;
          this.audioList[index].watchNum += 1;
        } else {
          this.$toast("网络异常");
        }
      });

    },

    // 获取最新添加音频
    getNewAdd(fn) {
      API.getNewAudio(
        {},
        {page:this.newPageParams.page,size:this.newPageParams.size},
        (res) => {
          if (res.code === 200) {
            fn(res);
          }
          console.log(res);
        }
      );
    },
    listenLogin() {
      if (isUserLogin()) {
        this.$refs.musicAudio.operation();
        this.checkLogin = true;
      }
    },
    confirmWay() {
      this.checkLogin = false;
      globalGoLogin()
      // 未注册用户弹窗确定埋点
      this.loginRegistSensors("确定");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: '凯淇育儿'
      });
    },
    cancleWay() {
      this.checkLogin = false;
      // 未注册用户弹窗取消埋点
      this.loginRegistSensors("取消");
      this.$refs.musicAudio.setAudioTime();

    },
    /**
     * @description:
     * @param {*} args
     * @return {*}
     */
    currentAudioWay(args) {
      this.audioParams = args[0];
      this.playIndex = args[1];
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    clearTimeWay() {
      this.$refs.musicAudio.clearTime();
    },
    /**
     * @description:
     * @param {*} obj
     * @return {*}
     */
    playaudioParams(obj) {
      this.addPalyNum(obj.id)
      //如果是组件点击播放最新不让联动
      if(obj.only){
        return false
      }
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = true;
        }
      });
    },
    /**
     * @description:音频暂停
     * @param {obj} 当前音频信息
     * @return {*}
     */
    pauseaudioParams(obj) {
      console.log(obj);
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = false;
        }
      });
    },
    /**
     * @description: //点击跳转
     * @param {status}  //true为最新的一弄数据 false为类别数据
     * @return {*}
     */
    senDetail(status) {
      if(status){ //为true走最新音频列表
        this.$refs.AudioList.onLinkTap(this.allNewAudio[this.playIndex], this.playIndex,this.allNewAudio[this.playIndex].authorId);
      }else{
        this.$refs.AudioList.onLinkTap(this.audioList[this.playIndex], this.playIndex,this.audioList[this.playIndex].authorId);
      }
    },
    /**
     * @description:
     * @param {status} //true为最新的一弄数据 false为类别数据
     * @return {*}
     */
    audioEvenTend(status) {
      if(status){
        this.list = this.allNewAudio
      }else{
        this.list = this.audioList
      }
      if (this.index ==this.list.length - 1 || this.playIndex === this.list.length - 1) {
        if (this.pageParams.audioFinished) {
          //判断数据列表
          if(!this.audioParams.only){
            this.playIndex = 0;
            this.index = 0 //切换下一首就给index赋值0
          }
        } else {
          this.sendNext();
        }
        // 最新数据分页
        if(this.audioParams.only && this.list.length >= this.totalElements){
          this.playIndex = 0
        }else if(this.audioParams.only){
          this.newPageParams.page++
          this.setNewAudio(1)
        }
      } else {
        //详情页返回给最新音频数据赋值下标
        if(this.index > 0){
          this.playIndex = this.index
        }
        this.playIndex++;
        this.index = 0 //赋值完成清除
        const { isios } = TestUserAgent();
        if (isios) {
          this.$refs.musicAudio.clearTime();
        }
      }
      this.list.forEach((res, i) => {
        if (this.playIndex == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.audioParams = this.list[this.playIndex];
    },
    goHomeTap() {
      this.goHomeSensor("点击");
      this.$router.push({
        path: "/home",
      });
    },

    goHomeSensor(msg) {
      sensors.track("buoy", {
        button_name: msg,
      });
    },

    // 播放下一个
    sendNext() {
      this.audiObj["type"] = 1;
      this.getDataList(this.audiObj);
    },
    //获取所有医生主页数据
    initAllExpert() {
      API.getkqAllExpert(
        {},
        {
          page: this.pageDoctorParams.page,
          size: this.pageDoctorParams.size,
        },
        (res) => {
          if (res.code === 200) {
            this.ExpertList = [...this.ExpertList, ...res.data.data];
            const HASMORE =
              res.data.total == 0 ||
              this.pageDoctorParams.size > res.data.data.length;

            if (HASMORE) {
              this.pageDoctorParams.loading = false;
              this.pageDoctorParams.audioFinished = true;
              this.pageDoctorParams.bottomText = "——已经到底了哦——";
            } else {

              this.pageDoctorParams.page+= 1;
              this.pageDoctorParams.loading = false;
              this.pageDoctorParams.audioFinished = false
               this.pageDoctorParams.bottomText = "";
            }
            if (this.sensorsFlagdoctor) {
              sensors.track("Kaiqi_Parenting_PV_UV", {
                Column: "医生专辑",
              });
              this.sensorsFlagdoctor = false;
            }
          } else {
            this.$toast("网络异常");
            this.pageDoctorParams.loading = false;
            this.pageDoctorParams.error = true;
            this.pageDoctorParams.audioFinished = true;
          }
        }
      );
    },
   /**
    * @description: 获取分类id
    * @param {id}分类id
    * @return {*}
    */

    getClassId(id,title) {
      this.playIndex = 0
      // this.setNewAudio()
      // this.allNewAudio = [] //切换标签直接清空数据
      console.log(id);
      if (this.audiObj["tagClassId"] === id) {
        return;
      }

      this.audiObj["tagClassId"] = id;
      this.audiObj["tagClassName"] = title;
      this.audioList = [];
      // this.audioParams = {};
      this.pageParams.page = 1;
      this.pageParams.loading = true;
      this.pageParams.audioFinished = false;
      this.pageParams.bottomText = "";
      this.getDataList(this.audiObj);
    },
    /**
    * @description: 获取月龄id
    * @param {id}月龄id
    * @return {*}
    */
    getTagAgeId(arg) {
      const [id, name] = arg;
      if (this.audiObj["tagAgeId"] === id) {
        return;
      }
      this.setNewAudio()
      this.allNewAudio = [] //切换标签直接清空数据
      this.intChildTag(id);
      // 月龄选择埋点
      sensors.track("Month_age_selection", {
        Month_age_stage: name,
        page_name: "凯淇育儿",
      });
      this.audiObj["tagAgeId"] = id;
      this.audioList = [];
      this.audioParams = {};
      this.pageParams.page = 1;
      // this.getDataList(this.audiObj);
    },

    async initMonthAge() {
      API.getkqMonthAge({}, (res) => {
        if (res.code === "200") {
          // Object.assign(res.data[0], { name: "全部" });

          this.monthAgeData = [
            ...this.monthAgeData,
            ...res.data.filter((res) => res.fnTagId !== "73"),
          ]; //过滤备孕
          this.audiObj["tagAgeId"] = this.monthAgeData[0].id;

          this.intChildTag(this.audiObj["tagAgeId"]); //初始化标签
        } else {
          this.$toast("网络异常");
        }
      });
    },
    intChildTag(id) {
      //每次选择月龄传id过去更新标签
      API.getkqChildTag({tagId:id} ,(res) => {
        if (res.code === 200) {
          this.audiObj["tagClassId"] = res.data[0].id;
          this.audiObj["tagClassName"] = res.data[0].name;
          this.tagList = res.data;
          console.log(res)
          if( this.tagList.length>0){
            this.getDataList(this.audiObj);
          }

        } else {
          this.$toast("网络异常");
        }
      });
    },
    // type 1 请求分页
    setNewAudio(type = "",callback) {
      let that = this;
      this.getNewAdd((res) => {
        var arrList = res.data.data
        for(var i = 0;i< arrList.length;i++){
          arrList[i].isPlay = false
          arrList[i].audioAddress = arrList[i].contentUrl
          arrList[i].only = 'only' //给最新音频加上唯一标识
        }
        this.allNewAudio = this.allNewAudio.concat(arrList)
        //分页数据渲染播放
        this.audioParams = arrList[0]
        var _index; //记录分页下标
        //找到分页第一条
        this.allNewAudio.findIndex((res, index) => {
          if (res.id == arrList[0].id) {
            _index = index;
          }
        });
        this.playIndex = _index //下标赋值
        if(type){
          //给最新分页数据渲染播放
          this.audioParams = this.allNewAudio[_index]
          this.audioParams.isPlay = true
        }else{
          this.audioParams = arrList[0]
        }
        that.totalElements = res.data.total
        callback(res)
      });
    },
    /**

    * @type  0和1 为1代表播放最后一页
    * @tagAgeId 月龄id
    * @tagClassId  标签id
    *  @callback 回调
    */
    getDataList({ type = "", tagAgeId = "", tagClassId = "" } = {}, callback) {
      if (tagClassId === "") {
        return;
      }
      const crmId = this.userInfo ? this.userInfo.crm_id : "";

      API.getkqAudioList(
        {},
        {
          tagAgeId: tagAgeId,
          tagClassId: tagClassId,
          crmId: crmId,
          page: this.pageParams.page,
          size: this.pageParams.size,
        },
        (res) => {
          this.pageParams.loading = false;
          if (res.code == 200) {
            var arrList = res.data.data;
            arrList.forEach((item, index) => {
              //为每一项{}添加一个播放标识 默认为false
              item.isPlay = false;
              item.audioAddress = item.contentUrl;
            });
            this.audioList = this.audioList.concat(arrList);
            if (this.pageParams.page == 1) {
              if (res.data.data.length == 0) {
                this.pageParams.bottomText = "";
              } else {

              }
            }
            const HASMORE =
              res.data.total == 0 ||
              this.pageParams.size > arrList.length;
            if (HASMORE) {
              this.pageParams.loading = false;
              this.pageParams.audioFinished = true;
              this.pageParams.bottomText = "——已经到底了哦——";
            } else {
              this.pageParams.page += 1;
            }

            // type为1 判断当前播放是否到最后一页
            if (type === 1) {
              if (HASMORE) {
                this.playIndex = 0;
              } else {
                this.playIndex++;
              }
              this.audioParams = this.audioList[this.playIndex];
            }

            if (this.sensorsFlag) {
              this.sensorsFlag = false;
              sensors.track("Kaiqi_Parenting_PV_UV", { Column: "育儿音频" });
            }
            console.log(this.audioParams);
            callback(res);
          } else {
            this.$toast("网络异常");
            this.pageParams.loading = false;
            this.pageParams.error = true;
            this.pageParams.audioFinished = true;
          }
        }
      );
    },

    tagClick(index) {
      if (this.tab_id === this.tabList[index].id) {
        return;
      }
      this.tagActive = index;
      this.tab_id = this.tabList[index].id;

      console.log(this.ExpertList);

      sensors.track("Kaiqi_Parenting_PV_UV", { Column: this.tabList[index].name });
    },
  },
};
</script>
<style lang="less" scoped>
.cage-child {
  .van-sticky .baby-tag{
   margin-top: 0px !important;
  }
  .sticky {
    position: fixed;
    top: 45px;
    background: #fff;
    z-index: 100;
    width: 100%;
  }
  /deep/ .van-sticky--fixed {
    background: #fff;
    z-index: 99;
  }
  /deep/ .van-list__finished-text {
    padding-bottom: 2.66667rem;
    background: #fff;
  }
  /deep/ .van-tabs__wrap{
    overflow-x: scroll;
  }
  /deep/ ::-webkit-scrollbar{
    display: none;
  }
  background: #fff;
  min-height: 100vh;
  .paddoffset {
    padding: 0 7px;
  }
  .paddingSet{
    padding-left: 12px;
    padding-right: 12px;
  }
  .cage-person {
    height: 134px;
    padding-top: 65px;
    padding-bottom: 0px;
    display: flex;
    align-items: center;
    &-txt {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      background: url("../../../assets/images/baby/cage_doctor_bg.png")
        no-repeat;
      background-size: 100% 100%;
      display: flex;
      padding: 5px 0px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a6864a;
      align-items: center;
      line-height: 22px;
      img {
        width: 79px;
        height: 114px;
      }
    }
  }
  .baby-tag {
    margin-top: 25px;
    font-size: 14px;
    font-weight: 500;
    font-family: PingFang-SC-Medium, PingFang-SC;
    color: #333333;
    display: flex;

    align-items: center;
    li {
      margin-right: 20px;
      position: relative;
    }
    &-active {
      font-size: 18px;
    }
    &-active::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0px;
      height: 3px;
      background:linear-gradient(270deg, #FED479 0%, #F0BA3B 100%);
      opacity: .8;
      // border: solid 1px #f0ba3b;
      width: 100%;
      border-radius: 2px;
    }
  }
}
</style>
